export function QueryState({ loading, error, empty, children, retry, emptyMessage }: {
  loading: boolean;
  error: boolean;
  empty?: boolean;
  retry?(): void;
  emptyMessage?: string;
  children: React.ReactNode;
}) {
  if (loading) {
    return <div className="state-panel" role="status">Loading current GTM data…</div>;
  }
  if (error) {
    return <div className="state-panel state-panel--error" role="alert">The console could not load this view. No action was taken.{retry ? <button type="button" className="button button--quiet" onClick={retry}>Try again</button> : null}</div>;
  }
  if (empty) {
    return <div className="state-panel">{emptyMessage || 'No records match this view. Try another status or reset the filters.'}</div>;
  }
  return <>{children}</>;
}
